const MobilePhoneValidator = (phoneValue: string | undefined): IMobilePhoneValidatorResult => {
    if (!phoneValue || !phoneValue.trim().length) return { passed: false, error: "Enter a phone" };
    const phoneRegex = /^\d{11}\W*$/;
    const phoneTest = !phoneRegex.test(phoneValue);
    if (phoneTest) return { passed: false, error: "Phone number should contain 11 digits" };
    return { passed: true };
};

export default MobilePhoneValidator;

interface IMobilePhoneValidatorResult {
    passed?: boolean;
    error?: PhoneValidatorError;
}

type PhoneValidatorError = "Enter a phone" | "Phone number should contain 11 digits";
export type { IMobilePhoneValidatorResult };
